export default __webpack_public_path__ + "static/media/icn-cnt-take-off.eb32f2ec.svg";